// Redimensionne une image choisie depuis l'ordinateur ou le téléphone et la
// convertit en data URL (base64) pour la stocker directement dans `photoUrl`.
// On borne la plus grande dimension et on ré-encode en JPEG afin que le poids
// reste modeste (< quelques centaines de Ko) et passe sous la limite de 1 Mo
// du corps de requête de l'API.
export async function fileToResizedDataUrl(
  file: File,
  maxSize = 800,
  quality = 0.82,
): Promise<string> {
  const dataUrl = await readFileAsDataUrl(file);
  const img = await loadImage(dataUrl);

  const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
  const width = Math.round(img.width * scale);
  const height = Math.round(img.height * scale);

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  if (!ctx) return dataUrl; // repli : on renvoie l'image d'origine
  ctx.drawImage(img, 0, 0, width, height);

  // Les PNG avec transparence sont préservés, sinon on compresse en JPEG.
  const type = file.type === "image/png" ? "image/png" : "image/jpeg";
  return canvas.toDataURL(type, quality);
}

function readFileAsDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("Image illisible"));
    img.src = src;
  });
}
